import Vue from 'vue'
import FiscalizationReport from './FiscalizationReport.vue'

if ($('#fiscalization_report_form').length) {
  new Vue({
    el: '#fiscalization_report_form',
    components: {
      FiscalizationReport
    }
  })
}
